import { render } from "./DeckblattList.pug?vue&type=template&id=f3347c84&lang=pug"
import script from "./DeckblattList.js?vue&type=script&lang=js"
export * from "./DeckblattList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__